import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobAlertSettingsAdminComponent } from './job-alert-settings-admin.component';
import { JobAlertSettingsEditModule } from './job-alert-settings-edit.module';

const routes: Routes = [
  {
    path: 'job-alert-settings-admin',
    component: JobAlertSettingsAdminComponent,
    data: { title: 'Job Notification Settings' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobAlertSettingsAdminRoutingModule {}

@NgModule({
  imports: [
    JobAlertSettingsAdminRoutingModule,
    JobAlertSettingsEditModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
  ],
  declarations: [JobAlertSettingsAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobAlertSettingsAdminModule {}
